import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import palmService from "../../services/palm-service";
import { Divider } from "antd";
import { ToastContainer, toast } from 'react-toastify';
import Swal from "sweetalert2";

const AdminPalms = () => {
  let navigate = useNavigate();
  const [formTitle, setFormTitle] = useState("Agregar nueva palma");
  const [listPalms, setListPalms] = useState([]);
  const [showEdit, setShowEdit] = useState(false);
  const [showSave, setShowSave] = useState(true);
  const [title, setTitle] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    reset,
    formState: { errors },
  } = useForm();

  const optionsState = [
    { id: true, name: "ACTIVO" },
    { id: false, name: "INACTIVO" },
  ];



  ////FUNCIONES QUE USAN EL SERVICIO palmService
  ////FUNCIONES QUE USAN EL SERVICIO palmService

  const getListByLine = async (line_id) => {
    const listado = await palmService.getListByLine(line_id);
    const quantity = listado.length + 1;
    setValue("name", quantity);
    setListPalms(listado);
  };

  const customSubmit = async (data) => {
    const quantity = listPalms.length + 1;
    const name = data.name
    if (name > quantity) {
      data.name = quantity
    }
    await palmService.insert(data);

    toast('Realizado.', { autoClose: 1000 });
    setValue("name", "");
    setValue("latitude", "");
    setValue("longitude", "");
    const line_id = localStorage.getItem("lineId");
    await getListByLine(line_id);

  };

  const getPalm = async (palmId) => {
    const palm = await palmService.getPalm(palmId);
    if (palm) {
      setValue("id", palm._id);
      setValue("name", palm.name);
      setValue("latitude", palm.latitude);
      setValue("longitude", palm.longitude);
      setValue("state", palm.state);
      setShowEdit(true);
      setShowSave(false);
      setFormTitle("Editar palma")
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };


  const deletePalm = async (palmId, palmName) => {

    const username = localStorage.getItem("username");
    if (username != "superadmin") {
      toast.error('Usuario sin privilegios de edición.', { autoClose: 1000 });
      return;
    }



    Swal.fire({
      title: `Desea eliminar la palma ${palmName}?`,
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: "Eliminar palma",
      denyButtonText: `Conservar`
    }).then(async (result) => {
      if (result.isConfirmed) {
        console.log("va a eliminar la palma siempre y cuando no tenga tareas, sino solo la desactiva")
        const id = palmId;
        const name = palmName;
        const data = { id, name };
        const responseData = await palmService.deletePalm(data);
        const success = responseData?.success || false
        console.log(responseData)
        if (success) {
          const line_id = localStorage.getItem("lineId");
          getListByLine(line_id);
          toast('Realizado.', { autoClose: 1000 });
          cancelar()
        }
        else {
          const message = responseData?.message || "error"
          toast.error(message, { autoClose: 1000 });
        }
      }
    });



    
  };



  const updatePalm = async () => {
    const id = getValues("id");
    const latitude = getValues("latitude");
    const longitude = getValues("longitude");
    const state = getValues("state");
    const name = getValues("name");
    const data = { id, state, latitude, longitude, name };
    const responseData = await palmService.update(data);
    const success = responseData?.success || false
    console.log(responseData)
    if (success) {
      const line_id = localStorage.getItem("lineId");
      getListByLine(line_id);
      toast('Realizado.', { autoClose: 1000 });
      cancelar()
    }
    else {
      const message = responseData?.message || "error"
      toast.error(message, { autoClose: 1000 });
    }
  };




  const cancelar = async () => {
    setShowEdit(false)
    setShowSave(true)
    const quantity = listPalms.length + 1;
    setValue("name", quantity);
    setValue("latitude", "");
    setValue("longitude", "");
    setValue("state", true);
    setFormTitle("Agregar nueva palma")
  };





  useEffect(() => {
    const line_id = localStorage.getItem("lineId");
    const line_name = localStorage.getItem("lineName");
    setValue("lineId", line_id);
    setValue("lineName", line_name);
    getListByLine(line_id);

    const farm_name = localStorage.getItem("farmName");
    const lot_name = localStorage.getItem("lotName");
    setTitle(`${farm_name} - ${lot_name}`);
  }, []);

  return (
    <div className="row p-4">
      <ToastContainer />

      <div className="col-12 " style={{ marginTop: "-10px" }}>
        <Divider orientation="left" style={{ border: "#AAAAAA" }} >Gestión de palmas - {title}</Divider>
      </div>


      <div className="col-12 ms-2">
        <Link to="/admin-lines" className="nav-link link-primary p-1">
          <i className="bi bi-arrow-left-short fa-lg"></i>
          <span className="fs-6 m-1">
            <strong>REGRESAR A LÍNEAS</strong>
          </span>
        </Link>
      </div>

      <div className="col-12 col-sm-4">
        <div className="card p-4">
          <form className="form-react" onSubmit={handleSubmit(customSubmit)}>
            <div className="row">
              <div className="card-title">
                <h4 className="text-secondary" >{formTitle}</h4>
              </div>

              <div className=" col-12 d-none">
                <label>Id Line</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("lineId")}
                />
              </div>



              <div className=" col-6">
                <label>Línea</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("lineName")}
                />
              </div>



              <div className=" col-12 d-none">
                <label>Id</label>
                <input
                  readOnly={true}
                  type="text"
                  className="form-control bg-light"
                  {...register("id")}
                />
              </div>



              <div className=" col-6">
                <label>Nombre</label>
                <input
                  type="number"
                  rules={{ required: true }}
                  className={showEdit ? "form-control bg-light" : "form-control"}
                  {...register("name")}
                />
                {errors.name?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
              </div>

              <div className=" col-6">
                <label>Latitud</label>
                <input
                  type="text"
                  rules={{ required: true }}
                  className="form-control"
                  {...register("latitude")}
                />
                {errors.latitude?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
              </div>

              <div className=" col-6">
                <label>Longitud</label>
                <input
                  type="text"
                  rules={{ required: true }}
                  className="form-control"
                  {...register("longitude")}
                />
                {errors.longitude?.type === "required" && (
                  <small className="text-danger">Campo requerido</small>
                )}
              </div>

              <div className=" col-12">
                <label>Estado</label>
                <select className="form-control" {...register("state")}>
                  {optionsState.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={showEdit ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <button className="btn btn-primary w-100" type="button"
                  onClick={() => updatePalm()}
                >
                  <i className="bi bi-save fa-lg m-2" /> Editar
                </button>
              </div>

              <div className={showSave ? " col-6" : "d-none"}>
                <label>&nbsp; </label>
                <button className="btn btn-primary w-100" type="submit">
                  <i className="bi bi-save fa-lg m-2" /> Guardar
                </button>
              </div>


              <div className=" col-6">
                <label>&nbsp; </label>
                <button
                  className="btn btn-secondary w-100"
                  type="button"
                  onClick={() => cancelar()}
                >
                  <i className="bi bi-x-square fa-lg m-2" /> Cancelar
                </button>
              </div>



            </div>
          </form>
        </div>
      </div>

      <div className="col-12 col-sm-8">
        <div className="card p-4">
          <div className="card-title">
            <h4 className="text-secondary" >Listado de palmas</h4>
            <h6 className="text-secondary" >*solo se pueden eliminar las palmas que no tienen movimientos</h6>
            <div className=" bdr">
              <table className="table">
                <thead className="table-primary">
                  <tr>
                    <th>Nombre</th>
                    <th>Latitud</th>
                    <th>Longitud</th>
                    <th>Estado</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {listPalms.map((palm) => {

                    const stateName = palm.state ? "Activa" : "Inactiva"

                    return (
                      <tr key={palm._id} className={palm.state ? "" : "table-secondary"} >
                        <td>{palm.name}</td>
                        <td>{palm.latitude}</td>
                        <td>{palm.longitude}</td>
                        <td>{stateName}</td>
                        <td style={{ width: "210px" }}>
                          <button className="btn btn-primary" onClick={() => getPalm(palm._id)} ><i className="bi bi-pencil-square fa-lg m-1" /> Editar</button>
                          <button className="btn btn-secondary ms-2" onClick={() => deletePalm(palm._id, palm.name)} ><i className="bi bi-trash fa-lg m-1" /> Elminar</button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>



    </div>
  );
};

export default AdminPalms;
